import type { FC } from 'react';

import { appConfig } from '../../../../../appConfig';
import type { BreadcrumbItem } from '../../../../common/components/molecules/Breadcrumbs';
import Breadcrumbs from '../../../../common/components/molecules/Breadcrumbs/Breadcrumbs';
import { useProductSectionsContext } from '../../../contexts/productSectionsContext';
import { useCurrentSectionParams } from '../../../hooks/useCurrentSectionParams';
import { buildAbsoluteUrl, buildSubSectionUrl } from '../../../utils/urlEcommerceUtils';

const ProductDetailsBreadcrumbs: FC<
    React.PropsWithChildren<{ name: string; productUrl: string }>
> = ({ name, productUrl }) => {
    const { sectionTree } = useProductSectionsContext();
    const { sectionTrail } = useCurrentSectionParams(sectionTree);

    const breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'Handla',
            type: 'home',
            url: buildAbsoluteUrl(appConfig.coopSettings.ecommerce.url),
            isLayoutRouterAsyncLink: true,
        },
        ...(sectionTrail.map((b, index, array) => ({
            name: b.name,
            type: 'category',
            url: buildSubSectionUrl(array, index),
            isLayoutRouterAsyncLink: false,
        })) || []),
        {
            name,
            type: 'current_page',
            url: productUrl,
            isLayoutRouterAsyncLink: false,
        },
    ];

    return <Breadcrumbs items={breadcrumbs} wrapperClasses="u-marginBsm" />;
};

export default ProductDetailsBreadcrumbs;
